/* eslint-disable no-nested-ternary */
import { color, Common } from '@stockbit/ui';
import Link from 'next/link';
import numeral from 'numeral';
import { Table, Th, Td } from '../styled';

const { Text, Flex } = Common;

const textColor = {
  profit: color.primary,
  loss: color.sunsetOrange,
  neutral: color.suvaGrey,
};

const priceSymbol = {
  profit: '+',
  loss: '-',
  neutral: '',
};

interface TableSymbolProps {
  topics: Array<any>;
  postedDate: string;
}

function TableSymbol({ topics, postedDate }: TableSymbolProps) {
  const columns = [
    {
      title: (
        <Th>
          <Text family="bold">Symbol</Text>
        </Th>
      ),
      dataIndex: 'symbol',
      key: 'symbol',
    },
    {
      title: (
        <Th>
          <Text family="bold" align="right">
            Posted on
          </Text>
          <Text color={color.dimgray} size="12px" align="right">
            {postedDate}
          </Text>
        </Th>
      ),
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: (
        <Th>
          <Text family="bold" align="right">
            Current Price
          </Text>
        </Th>
      ),
      dataIndex: 'change',
      key: 'change',
    },
  ];

  const dataSource = topics.map((topic) => {
    let priceStatus = 'neutral';

    if (topic?.pchange > 0) {
      priceStatus = 'profit';
    } else if (topic?.pchange < 0) {
      priceStatus = 'loss';
    }

    const price = topic.price || parseInt(topic.price, 10) === 0
      ? numeral(topic.price).format('0,0[.]00')
      : 'NA';

    const lastPrice = topic.latest
      ? numeral(topic.latest.lastprice).format('0,0[.]00')
      : null;

    const change = topic.change || parseInt(topic.change, 10) === 0
      ? numeral(topic.change).format('0[.]00')
      : 'NA';

    const pChange = topic.pchange || parseInt(topic.pchange, 10) === 0
      ? numeral(Math.abs(topic.pchange)).format('0.00')
      : null;

    return {
      key: '1',
      symbol: (
        <Td>
          <Link href={`/symbol/${topic.symbol}`}>
            <a target="_blank" rel="noopener noreferrer">
              <Text color={color.primary} height="1.55">{topic.symbol}</Text>
            </a>
          </Link>
        </Td>
      ),
      price: (
        <Td>
          <Text
            align="right"
            height="1.55"
            color={color.nero}
          >
            {price}
          </Text>
        </Td>
      ),
      change: (
        <Td>
          <Flex justify="end" align="center">
            <Text align="right" color={color.nero} height="1.55">
              {lastPrice}{' '}
            </Text>
            <Text
              as="span"
              color={textColor[priceStatus]}
              align="right"
              ml="5px"
              style={{ minWidth: '100px' }}
            >
              {change} {' '}
              ({priceSymbol[priceStatus]}{pChange}%)
            </Text>

          </Flex>
        </Td>
      ),
    };
  });

  return <Table columns={columns} dataSource={dataSource} pagination={false} />;
}

export default TableSymbol;
